import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_send_order_delivery_complete} from "../../../../function/FnBodyStep";
import { fn_bridge_pos_order_sale } from "function/FnPosBridge"
import { posOrdermMbileOrderFg } from "utils/Utils"

@observer
class OrderCompleteView extends Component {

    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerOrderCompleteView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>주문 완료처리</h1>
                        </div>
                        <div className="section_soldout">
                            <p className="txt_detail">
                                완료처리 시, 일부 주문정보 조회가 불가합니다.<br />완료처리 하시겠습니까?
                            </p>
                            <div className="wrap_full_btn wrap_full_btn2">
                                <span className="f_l"><button className="btn_cancel"
                                onClick={event => rootStore.layerStore.setLayerOrderComplete(false)}
                                >취소</button></span>
                                <span className="f_r"><button className="btn_submit"
                                onClick={event => 
                                    (posOrdermMbileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg))
                                    ? fn_bridge_pos_order_sale(rootStore, rootStore.viewStore.getOrderDetail)   
                                    : fn_send_order_delivery_complete(rootStore)
                                }
                                >확인</button></span>
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button onClick={event => rootStore.layerStore.setLayerOrderComplete(false)}><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderCompleteView;